"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const GraphandFieldDate_1 = __importDefault(require("./fields/GraphandFieldDate"));
const GraphandFieldJSON_1 = __importDefault(require("./fields/GraphandFieldJSON"));
const GraphandFieldRelation_1 = __importDefault(require("./fields/GraphandFieldRelation"));
const GraphandFieldText_1 = __importDefault(require("./fields/GraphandFieldText"));
const GraphandModel_1 = __importDefault(require("./GraphandModel"));
class GraphandHistoryModel extends GraphandModel_1.default {
    static get baseFields() {
        return {
            diffs: new GraphandFieldJSON_1.default(),
            date: new GraphandFieldDate_1.default({ time: true }),
            kind: new GraphandFieldText_1.default({ options: ["create", "update", "delete"] }),
            "metas.account": new GraphandFieldRelation_1.default({ ref: "Account", multiple: false }),
        };
    }
}
exports.default = GraphandHistoryModel;
